import React from "react";
import PlpUrlChangeComponent from '../components/PlpUrlChange'; // ✅ Renamed the import

function PlpUrlChange() {
  return (
    <div>
      <h1>PLP URL Change Page</h1>
      <PlpUrlChangeComponent />  {/* ✅ Using the renamed import */}
    </div>
  );
}

export default PlpUrlChange;
